import IEmailViewModel from "./Interfaces/IEmailViewModel";
import IPhoneNumberViewModel from "./Interfaces/IPhoneViewModel";
import IPostalAddressViewModel from "./Interfaces/IPostalAddressViewModel";

declare const basePath: string;

export default class ApiClient {
    public getPostalAddressCard(viewModel: IPostalAddressViewModel, index: number): JQuery.jqXHR {
        const url = `${basePath}Contact/GetPostalAddressCard`;
        const data = {
            viewModel,
            index,
        };

        return jq.post(
            {
                url,
                data,
            },
        );
    }

    public getPostalAddressEditor(viewModel: IPostalAddressViewModel): JQuery.jqXHR {
        const url = `${basePath}Contact/GetPostalAddressEditor`;
        const data = {
            viewModel,
        };

        return jq.post(
            {
                url,
                data,
            },
        );
    }

    public getPhoneNumberEditor(viewModel: IPhoneNumberViewModel): JQuery.jqXHR {
        const url = `${basePath}Contact/GetPhoneNumberEditor`;
        const data = {
            viewModel,
        };

        return jq.post(
            {
                url,
                data,
            },
        );
    }

    public getEmailEditor(viewModel: IEmailViewModel): JQuery.jqXHR {
        const url = `${basePath}Contact/GetEmailEditor`;
        const data = {
            viewModel,
        };

        return jq.post(
            {
                url,
                data,
            },
        );
    }

    public getGeneratedUserPassword(): JQuery.jqXHR<string> {
        const url = `${basePath}Registration/GenerateUserPassword`;

        return jq.get(
            {
                url,
            },
        );
    }
}
